<template>
  <div>文章详情页面</div>
</template>

<script>
export default {

}
</script>

<style>

</style>